import {
    SET_ERRORS,
    CLEAR_ERRORS,
    LOADING_UI,
    STOP_LOADING,
    TOGGLE_THEME
} from '../types'

export interface UiType {
    loading: boolean,
    errors: any,
    dark: boolean
}

const initialState: UiType = {
    loading: false,
    errors: {},
    dark: false
}

export default function (state = initialState, action: any) {
    switch (action.type) {
        case SET_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            }

        case CLEAR_ERRORS:
            return {
                ...state,
                loading: false,
                errors: {}
            }

        case LOADING_UI:
            return {
                ...state,
                loading: true
            }

        case STOP_LOADING:
            return {
                ...state,
                loading: false
            }

        case TOGGLE_THEME:
            console.log("isDark: ", !state.dark)
            return {
                ...state,
                dark: !state.dark
            }

        default:
            return state
    }
}